// removed by extract-text-webpack-plugin
module.exports = {"this":"ModalTrigger__this___29l_C"};


//////////////////
// WEBPACK FOOTER
// ./src/components/styles/ModalTrigger.css
// module id = 1219
// module chunks = 4